import axios from 'axios';
import PATH from './URL'


function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

async function SaveOrder(func, event, shop){
    const csrftoken = getCookie('csrftoken');
    let options = {
        method:'POST',
        headers:{ 'X-CSRFToken': csrftoken, 'Content-Type' : 'application/x-www-form-urlencoded'},
        data:{
            'phone':event.target.phone.value,
            'email':event.target.email.value,
            'first_name':event.target.first_name.value,
            'last_name':event.target.last_name.value,
            'detail':event.target.details.value,
            'shop':shop,
            },
        url: `${PATH}/api/v1/save-order`
    }
    const response = await axios(options)
    return func(response.data)
}

export default SaveOrder